/** Mirrors InviteCloudBackend/src/modules/cart/cart.constants.ts — display-only caps; the backend is the enforced source of truth. */
export const MAX_CART_ITEM_QUANTITY = 10;
export const MIN_CART_ITEM_QUANTITY = 1;
export const MAX_UNITS_PER_CHECKOUT = 20;
